<template>
  <p class="text-body-1">
    <slot></slot>
  </p>
</template>

<script>
export default {
};
</script>

<style>

</style>
